/**
 * Every word on the main menu, the mode cards and the join row.
 *
 * Chrome, in the register [src/text/AGENTS.md](./AGENTS.md) calls chrome: the
 * game has not started, nothing here is in the fiction, and a player deciding whether to press
 * anything needs plain words rather than voice.
 *
 * Here rather than in the builders because three files render this screen and two of them render
 * the word "Join". Wording that lives at its use site is wording that drifts.
 *
 * Short by rule. The menu is read on every trip back from a game, so a sentence here is a sentence
 * read a hundred times. A button says what it does, a chip says one fact, and nothing explains.
 */

/** The game's name, until it has one. */
export const MENU_WORDMARK = 'TBD';
export const MENU_SECTION = 'Game modes';

/** The button that opens the character sheet, and the title on the sheet it opens. */
export const MENU_LEVEL_UP = 'Level up';
/** On every sheet, because a panel that opens over the menu has to say how to leave. */
export const MENU_SHEET_CLOSE = 'Close';

export const MODE_SOLO = 'Play solo';
export const MODE_HOST = 'Host co-op';

/**
 * On the pressed button while the mode is being fetched. A verb rather than a noun, because it is
 * the press being answered and not a state being reported.
 */
export const MODE_STARTING = 'Starting';

/**
 * A mode's code is downloaded when it is picked, so a mode can now fail to start for a reason that
 * has nothing to do with a session or a machine.
 *
 * The advice is to reload rather than to press again, and that is not politeness: a browser records
 * a failed module fetch and hands the same failure back to every later request for it, so pressing
 * again cannot work. Reloading is also what fixes the likeliest cause, which is a build that was
 * replaced while this tab was open and left it asking for files that are no longer there.
 */
export const MODE_UNAVAILABLE = {
  message: 'That mode did not finish downloading.',
  advice: 'Reload the page and try again.',
};

/**
 * The one chip about controls, on a card whose mode cannot be played by touch.
 *
 * Only the exception is said. Every mode plays with a mouse, so a chip saying so on every card is
 * a row of identical chips nobody reads, and the one card that differs is lost among them.
 */
export const MODE_MOUSE_ONLY = 'Mouse only';

/** The title over the join box. The button inside it does not repeat it. */
export const JOIN_TITLE = 'Join with a code';
export const JOIN_FIELD_LABEL = 'Join code';
/** A verb for what the press does, rather than a second copy of the title above the box. */
export const JOIN_ACTION = 'Connect';
/** A shape, not a real code. Reads as an example because the parser would accept it. */
export const JOIN_PLACEHOLDER = 'RUST-7F2K';
